<template>
  <div>
  

        
       
       
       <div style="margin-top:90px;">
       <h5 style="font-weight:bold;">E-Signing Overview</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="summary">
                <el-table-column label="Month" property="month" ></el-table-column>
                <el-table-column label="No. Of Documents Sent For E-signing" property="count"></el-table-column>

                 
            </el-table>

          </div>
        </div>
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.loadOverview();
    },
    
     
    data () {
      return {
        coy:[],
        summary:[],
    	eid: this.$route.params.eid,
		 new_mail: {
          document_name: '',
          notes:'',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    loadOverview(){
	    	let uri = this.$base_url+'/api/v1/entities/get/esigning-overview';
			 ApiService.get(uri).then(response => {
					this.summary = response.data.summary;
			})
	    },
	  
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


